"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2006ToJSON = exports.InlineResponse2006FromJSONTyped = exports.InlineResponse2006FromJSON = void 0;
function InlineResponse2006FromJSON(json) {
    return InlineResponse2006FromJSONTyped(json, false);
}
exports.InlineResponse2006FromJSON = InlineResponse2006FromJSON;
function InlineResponse2006FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isAccountConnected': json['isAccountConnected'],
    };
}
exports.InlineResponse2006FromJSONTyped = InlineResponse2006FromJSONTyped;
function InlineResponse2006ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isAccountConnected': value.isAccountConnected,
    };
}
exports.InlineResponse2006ToJSON = InlineResponse2006ToJSON;
